import Vue from 'vue'
import Vuex from 'vuex'
import { API } from 'aws-amplify';

Vue.use(Vuex)

function getUpdated(state, nickname, response) {
  const index = state.coffees.findIndex(element => element.nickname === nickname);
  return state.coffees.map((v, i) => i === index ? response : v);
}


export default new Vuex.Store({
  state: {
    user: null,
    coffees: [],
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setCoffees(state, coffees) {
      state.coffees = coffees;
    },
    setConfiguration(state, config) {
      state.configuration = config;
    }
  },
  actions: {
    async fetchConfiguration({ commit }) {
      try {
        const response = await API.get('coffees', "/configurations");
        commit('setConfiguration', response);
      } catch (err) {
        console.log(err);
        commit('setConfiguration', null);
      }
    },
    async fetchCoffees({ commit }) {
      const response = await API.get("coffees", "/coffees");
      commit('setCoffees', response);
    },
    async updateCoffeeAmount({ commit }, { nickname, amount }) {
      const response = await API.put('coffees', '/coffees', {
        body: {
          nickname,
          amount
        }
      })
      const index = this.state.coffees.findIndex(element => element.nickname === nickname);
      const updated = this.state.coffees.map((v, i) => i === index ? response : v);
      commit('setCoffees', updated);
    },
    async createCoffeeAccount({ commit }, nickname) {
      const response = await API.post('coffees', '/coffees', {
        body: {
          nickname
        }
      });
      const updated = [...this.state.coffees, response]
      commit('setCoffees', updated);
    },
    async updateMilkSchedule({ commit }, { nickname, months }) {
      const response = await API.put('coffees', '/milkschedule', {
        body: {
          nickname,
          months
        }
      });
      commit('setCoffees', getUpdated(this.state, nickname, response));
    }
  }
})
